import {yupResolver} from '@hookform/resolvers/yup'
import {FC, useEffect, useRef, useState} from 'react'
import {FormProvider, useForm} from 'react-hook-form'
import {StepperComponent} from '../../../../../../../_metronic/assets/ts/components'
import {checkinParkingSchemas} from '../../../../../util/validationHoteleria'
import {CheckinParking} from '../../../models/ckecking.model'
import {FormStep0Parking} from '../forms/FormStep0Parking'
import {FormStep1Parking} from '../forms/FormStep1Parking'
import {FormStep2Parking} from '../forms/FormStep2Parking'
import {FormStep3Parking} from '../forms/FormStep3Parking'
import {FormStep4Parking} from '../forms/FormStep4Parking'
// To use Html5QrcodeScanner (more info below)

const inits: CheckinParking = {
  operationType: '',
  isGuest: false,
  AceptaTyC: false,
  errorCheck: false,
  tipoDocumentoId: '01',
  fromCamera: false,
  numeroDocumento: '',
}

const CheckInParking: FC = () => {
  const stepperRef = useRef<HTMLDivElement | null>(null)
  const stepper = useRef<StepperComponent | null>(null)
  const [currentSchema, setCurrentSchema] = useState(checkinParkingSchemas[0])
  const [initValues] = useState<CheckinParking>(inits)
  const [currentStepIndex, setCurrentStepIndex] = useState(0)

  const methods = useForm<CheckinParking>({
    defaultValues: initValues,
    resolver: yupResolver(currentSchema),
  })

  const {
    reset,
    // watch,
    setValue,
  } = methods

  const loadStepper = () => {
    stepper.current = StepperComponent.createInsance(stepperRef.current as HTMLDivElement)
  }

  const prevStep = () => {
    if (!stepper.current) {
      return
    }
    stepper.current.goPrev()
    setCurrentSchema(checkinParkingSchemas[currentStepIndex - 1])
    setCurrentStepIndex((prevIndex) => prevIndex - 1)
  }

  const nextStep = () => {
    if (!stepper.current) {
      return
    }
    setCurrentSchema(checkinParkingSchemas[currentStepIndex])
    if (currentStepIndex !== stepper.current.totatStepsNumber) {
      stepper.current.goNext()
      setCurrentStepIndex((prevIndex) => prevIndex + 1)
    }
  }

  const goToFirstStep = () => {
    if (!stepper.current) {
      return
    }
    stepper.current.goto(1)
    setCurrentStepIndex(0)
    setCurrentSchema(checkinParkingSchemas[0])
    reset()
  }

  const goToStep = (index: number) => {
    if (!stepper.current) {
      return
    }
    stepper.current.goto(index)
    setCurrentStepIndex(index - 1)
    setCurrentSchema(checkinParkingSchemas[index - 1])
  }

  useEffect(() => {
    if (!stepperRef.current) {
      return
    }

    loadStepper()
  }, [stepperRef])

  useEffect(() => {
    setValue('tipoDocumentoId', '01')
    setValue('numeroDocumento', '')
  }, [])

  return (
    <div className='card'>
      <div className='card-body'>
        <div
          ref={stepperRef}
          className='stepper stepper-links d-flex flex-column pt-15'
          id='kt_create_account_stepper'
        >
          <div className='stepper-nav mb-5'>
            <div className='stepper-item current' data-kt-stepper-element='nav'>
              <h3 className='stepper-title'>Operación</h3>
            </div>
            <div className='stepper-item' data-kt-stepper-element='nav'>
              <h3 className='stepper-title'>Ingresar Datos</h3>
            </div>

            <div className='stepper-item' data-kt-stepper-element='nav'>
              <h3 className='stepper-title'>Escanea</h3>
            </div>

            <div className='stepper-item' data-kt-stepper-element='nav'>
              <h3 className='stepper-title'>Información</h3>
            </div>

            <div className='stepper-item' data-kt-stepper-element='nav'>
              <h3 className='stepper-title'>Resultados</h3>
            </div>
          </div>

          <FormProvider {...methods}>
            <form
              className='mx-auto mw-600px w-100 pt-15 pb-10'
              id='kt_create_account_form'
              // onSubmit={handleSubmit(submitStep)}
            >
              {/* Solo renderiza el paso actual */}
              {currentStepIndex === 0 && (
                <FormStep0Parking
                  nextStep={nextStep}
                  prevStep={prevStep}
                  // stepper={stepper}
                  // goToFirstStep={goToFirstStep}
                  // goToStep={goToStep}
                />
              )}
              {currentStepIndex === 1 && (
                <FormStep1Parking
                  nextStep={nextStep}
                  prevStep={prevStep}
                  stepper={stepper}
                  goToFirstStep={goToFirstStep}
                  goToStep={goToStep}
                />
              )}
              {currentStepIndex === 2 && (
                <FormStep2Parking
                  nextStep={nextStep}
                  prevStep={prevStep}
                  stepper={stepper}
                  goToFirstStep={goToFirstStep}
                  goToStep={goToStep}
                />
              )}
              {currentStepIndex === 3 && (
                <FormStep3Parking
                  nextStep={nextStep}
                  prevStep={prevStep}
                  stepper={stepper}
                  goToFirstStep={goToFirstStep}
                  goToStep={goToStep}
                />
              )}
              {currentStepIndex === 4 && (
                <FormStep4Parking
                  nextStep={nextStep}
                  prevStep={prevStep}
                  stepper={stepper}
                  goToFirstStep={goToFirstStep}
                  goToStep={goToStep}
                />
              )}
            </form>
          </FormProvider>
        </div>
      </div>
    </div>
  )
}

export default CheckInParking
